import React from 'react';
import NewLogin from '../../lis-login/components/lis-new-login-form';
import Login from '../../lis-login/components/lis-login-form';
import UserProfile from './lis-profile-component';
import NewUserProfile from './lis-new-profile-component'
import { usePKCE } from '../../../authConfig';

class Submenu extends React.Component {

    render() {
        const {
            isAuth
        } = this.props;

        if (!isAuth) {
            return (
                <ul className="nav-submenu" id="login">
                    {usePKCE ? <NewLogin
                        history={this.props.history}
                        isSubmenu={true}
                    /> :
                        <Login
                            history={this.props.history}
                            isSubmenu={true}
                        />
                    }
                </ul>
            )
        }
        else {
            return (
                <ul className="nav-submenu" id="profile">
                    {usePKCE ? <NewUserProfile permissions={this.props.permissions} /> : <UserProfile permissions={this.props.permissions} />}
                </ul>
            )
        }
    }
}

export default Submenu;
